import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getLocationPrivileges } from 'src/app/privileges/privileges.selector';
import { LocationDetailSaveEvent } from '../models/location-detail-form-submit-event';
import { LocationDetailView } from '../models/location-detail-view.model';
import { LocationPrivileges } from '../models/location-privileges';
import { LocationDetailFormService } from '../services/location-detail-form.service';
import * as LocationDetailActions from '../state/location-detail.actions';
import { getLocation, getLocationCallState } from '../state/location-detail.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [LocationDetailFormService, { provide: FormsBase, useExisting: LocationDetailFormService }],
    selector: 'ndt-location-detail',
    templateUrl: './location-detail.component.html',
    standalone: false
})
export class LocationDetailComponent extends Detail<LocationDetailFormService> implements OnDestroy {
   location$: Observable<LocationDetailView | null>;

   callState$: Observable<CallState>;

   locationPrivileges$: Observable<LocationPrivileges>;

   constructor(public store: Store, private router: Router, protected formService: LocationDetailFormService) {
      super(store, formService);
      this.location$ = this.store.pipe(select(getLocation));
      this.callState$ = this.store.pipe(select(getLocationCallState));
      this.locationPrivileges$ = this.store.pipe(select(getLocationPrivileges));
      this.store.dispatch(LocationDetailActions.locationDetailLoad());
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(LocationDetailActions.locationDetailCancel());
   }

   onFormSubmitted(event: LocationDetailSaveEvent): void {
      this.store.dispatch(LocationDetailActions.saveLocationDetail(event));
   }

   onDeleteLocation(event: { locationId: number }) {
      this.store.dispatch(LocationDetailActions.deleteLocation(event));
   }
}
